import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux'
import Icon from '../components/Icon';

import {loginUser} from '../../reducers2/login';
import history from '../../libs/history';
import {Button} from "../components/Button";
import Title from "../components/Title";
import createLink from "../../libs/createLink";
import {fetchCurrentUser} from "../../creators/currentUser";
import Helmet from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import _ from "lodash";
import {SpinLoader} from "../components/Loader";
import {contextBigPlan} from "../../libs/contextBigPlan";


class Signin extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmitSignin = this.handleSubmitSignin.bind(this);
        this.state = {
            login: '',
            password: '',
            showPassword: false,
            isLoadAccount : false
        }
    }

    componentWillMount() {
        // if (this.props.login.authenticated) history.push(this.redirectTo());
        // else {
        //     this.props.resetLoginAuthentication();
        // }
    }


    redirectTo() {
        let currentDomain = window.location.hostname;
        let referrer = document.referrer;
        let redirection = '/';
        if (referrer.indexOf(currentDomain) >= 0 && referrer.indexOf(createLink("signin")) <= 0) {
            redirection = referrer.replace(window.location.origin, "");
        }
        return redirection;
    }

    handleKeyPress(event) {
        if (event.key === "Enter") {
            this.handleSubmitSignin(event)
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loginAuthenticated !== this.props.loginAuthenticated) {
            this.setState({isLoadAccount : true});
            this.props.fetchCurrentUser().then((response)=>{
                let isToggle = _.get(response, "payload.setting.displayBigPlan") || false
                localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`, isToggle);
                this.context.setFilterToggle({isToggle});
                if(this.props.isModal){
                    this.props.handleClose();
                }
                else{
                    history.push(this.redirectTo());
                }
            });
        }
    }

    handleSubmitSignin(e) {
        e.preventDefault();
        if (!this.props.login.loading) {
            this.props.loginUser(this.state);
            /*this.props.loginUser(this.state).then(({error}) => {
                if (!error) {
                    this.props.fetchCurrentUser().then(()=>{
                        if(this.props.isModal){
                            this.props.handleClose();
                        }
                        else{
                            history.push(this.redirectTo());
                        }
                    });
                }
                else{
                    this.props.loginUser(this.state);
                }
            });*/
        }
    }

    render() {
        return (
            <div id="signin" className={this.props.isModal ? "small-container" : ""}>
                {!this.props.isModal && (
                    <Helmet>
                        <title>{config.preTitle}Connexion{config.postTitle}</title>
                        <link rel="canonical" href={canonical(createLink("signin"), "", "signin")} />
                    </Helmet>
                )}
                <div className="black-layer"/>
                <div className="container">
                    {this.state.isLoadAccount ? (
                        <div className="card">
                            <div className="main-wrapper">
                                <Title heading={"heading-1"} display={"display-1"}>Voissa</Title>
                                <div className={"loading-account"}><SpinLoader /></div>
                            </div>
                        </div>
                    ) : (
                        <div className="card">
                            <div className="main-wrapper">
                                <Title heading={"heading-1"} display={"display-1"}>Voissa</Title>

                                <form className="form-signin" onSubmit={(e) => this.handleSubmitSignin(e)} autoComplete="on"
                                      noValidate>
                                    <div className="input-wrapper">
                                        <Icon type="user-o"/>
                                        <input className="bottom-bar-style" type="text" placeholder="Nom d'utilisateur"
                                               name="login" value={this.state.login}
                                               autoComplete={"username"}
                                               onChange={e => this.setState({login: e.target.value})}
                                               onKeyPress={(event) => this.handleKeyPress(event)}/>
                                    </div>
                                    <div className="input-wrapper password">
                                        <Icon type="lock"/>
                                        <input className="bottom-bar-style"
                                               type={this.state.showPassword ? "text" : "password"}
                                               placeholder="Mot de passe"
                                               name="password" autoComplete="current-password" value={this.state.password}
                                               onChange={e => this.setState({password: e.target.value})}
                                               onKeyPress={(event) => this.handleKeyPress(event)}/>
                                        <span className={"show-password"}
                                              onClick={() => this.setState({showPassword: !this.state.showPassword})}>
                                        <Icon type={this.state.showPassword ? "eye-cut" : "eye"}/>
                                        </span>
                                    </div>
                                    <div className="forgot-password-link">
                                        <Link to={createLink("forgotPassword")}>J'ai oublié mon mot de passe</Link>
                                    </div>
                                </form>
                                {/*<div className="input-group-checkbox">*/}
                                {/*    <div className="group-checkbox">*/}
                                {/*        <input type="checkbox" id="remember"/>*/}
                                {/*        <label htmlFor="remember" className="label">Se souvenir de moi</label>*/}
                                {/*    </div>*/}
                                {/*    <span className={"show-information"}><Icon type={"question-circle"}/> <div*/}
                                {/*        className="advertissement">Ceci n'est pas recommandé pour les ordinateurs partagés.</div></span>*/}
                                {/*</div>*/}
                                {/*<div className="input-group-checkbox">*/}
                                {/*    <div className="group-checkbox">*/}
                                {/*        <input id="invisible" type="checkbox"/>*/}
                                {/*        <label htmlFor="invisible" className="label">Connexion en tant qu'invisible</label>*/}
                                {/*    </div>*/}
                                {/*    <span className={"show-information"}><Icon type={"question-circle"}/><div*/}
                                {/*        className="advertissement">Ne m'ajoutez pas à la liste des utilisateurs actifs.</div></span>*/}

                                {/*</div>*/}
                            </div>
                            <div className="btn-group">
                                <Button size={"medium"}
                                        btnStyle={"primary-reverse"}
                                        className={"btn-signin"}
                                        loading={this.props.login.loading}
                                        btnType={"submit"}
                                        onClick={(event) => this.handleSubmitSignin(event)}
                                        content={"Connexion"}/>
                            </div>
                            <div className="flex-jc-c">OU</div>
                            <div className="btn-group">
                                <Link to={createLink("signup")}>
                                    <Button size={"medium"}
                                            className={"btn-signup"}
                                            btnStyle={"primary-reverse"}
                                            content={"Inscription"}
                                    />
                                </Link>
                            </div>
                            {this.props.login.error && this.props.login.error.statusCode === 400 && _.get(this.props,"login.error.errors.isBan") ? (
                                <div className="warning">
                                    <p >Votre profil a été banni de Voissa {this.props.login.error.message !== "Bad Request" ? "pour la raison suivante :" : ""} </p>
                                    {this.props.login.error.message !== "Bad Request" ? <p >{this.props.login.error.message}</p> : null}
                                    <p >Pour toute question veuillez nous <Link to={createLink("contact")}>Contacter</Link></p>
                                </div>
                            ) : null
                            }
                            <div className={"signup-link"}><Link to="/cgus">Conditions générales</Link></div>
                            {this.props.login.error && this.props.login.error.statusCode === 401 &&
                            <p className="warning">Email ou mot de passe invalide</p>}

                            {this.props.login.error && this.props.login.error.statusCode === 429 &&
                            <p className="warning">Trop de demandes, veuillez réessayer dans 10 minutes</p>}
                            {/*<div className="signup-link">
                                <div className="text-signup-link">Besoin d'un compte ? <Link to={createLink("signup")}>Inscrivez vous
                                    maintenant !</Link></div>
                            </div>*/}
                        </div>
                    )}

                    <div className="signin-ad">
                        <div className="black-layer"/>
                        <div className="content">
                            <div className="title">Pas encore inscrit sur Voissa ?</div>
                            <div className="sub-title">Révélez-vous ! Le plus bel espace de liberté</div>
                            <Button size="large"
                                    to={createLink("signup")}
                                    btnStyle="primary-reverse"
                                    content="Créer un compte gratuitement"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Signin.contextType = contextBigPlan;

const mapStateToProps = state => ({
    login: state.login,
    loginLoading: state.login.loading,
    loginError: state.login.error,
    loginAuthenticated: state.login.authenticated,
});


const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    loginUser,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
